import dayjs from 'dayjs';

interface PlanValidity {
  validfor: number;
  validUnit: 'days' | 'months' | 'years';
}

/**
 * Calculate expiry date based on current date + validity
 */
export const calculatePlanExpiryDate = (planValidity: PlanValidity): Date => {
  if (!planValidity?.validfor || !planValidity?.validUnit)
    throw new Error('Invalid plan validity');

  return dayjs().add(planValidity.validfor, planValidity.validUnit).toDate();
};
